"use strict";
/**
 * Class description
 *
 * Created: 2017-11-10
 * @author jonas
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLoader = exports.AssetsQualitySetting = void 0;
const Logger_1 = require("@nolimit/slot-launcher/bin/utils/Logger");
const APIOptions_1 = require("@nolimit/slot-launcher/bin/interfaces/APIOptions");
const APIErrorSystem_1 = require("@nolimit/slot-launcher/bin/interfaces/APIErrorSystem");
const APIEventSystem_1 = require("@nolimit/slot-launcher/bin/interfaces/APIEventSystem");
const Asset_1 = require("./Asset");
const TextureParser_1 = require("./parsers/TextureParser");
const SpineAssetParser_1 = require("./parsers/SpineAssetParser");
const ResourcesGroupName_1 = require("./ResourcesGroupName");
const AssetLoaderEvent_1 = require("./AssetLoaderEvent");
const AssetsConfig_1 = require("./AssetsConfig");
var AssetsQualitySetting;
(function (AssetsQualitySetting) {
    AssetsQualitySetting[AssetsQualitySetting["NONE"] = 0] = "NONE";
    AssetsQualitySetting[AssetsQualitySetting["LOW"] = 1] = "LOW";
    AssetsQualitySetting[AssetsQualitySetting["MEDIUM"] = 2] = "MEDIUM";
    AssetsQualitySetting[AssetsQualitySetting["HIGH"] = 3] = "HIGH";
})(AssetsQualitySetting || (exports.AssetsQualitySetting = AssetsQualitySetting = {}));
class AssetLoader {
    constructor(apiPlugin, baseUrl) {
        this._apiPlugin = apiPlugin;
        this._apiPlugin.events.on(APIEventSystem_1.APIEvent.HALT, () => this.halt());
        this._baseUrl = baseUrl;
        this._events = this._apiPlugin.eventSystemFactory.create();
        this.createLoader();
    }
    createLoader() {
        this._loader = new PIXI.Loader(undefined, 10000);
        this._textureParser = new TextureParser_1.TextureParser(this._loader);
        this._spineAssetParser = new SpineAssetParser_1.SpineAssetParser(this._loader, this);
        const blobParser = this._loader._afterMiddleware[0];
        const textureParser = this._loader._afterMiddleware[1];
        const bitmapFontParser = this._loader._afterMiddleware[2];
        const spriteSheetParser = this._loader._afterMiddleware[3];
        const spineParser = this._loader._afterMiddleware[4];
        this._loader._afterMiddleware = [];
        this._loader._afterMiddleware.push(blobParser);
        //(<any>this._loader)._afterMiddleware.push(textureParser);
        this._loader._afterMiddleware.push(bitmapFontParser);
        // (<any>this._loader)._afterMiddleware.push(spriteSheetParser);
        // (<any>this._loader)._afterMiddleware.push(spineParser);
        this._loader.use((resource, next) => this._textureParser.parseResource(resource, next));
        this._loader.use((resource, next) => this._spineAssetParser.parseResource(resource, next));
        this._loader.onProgress.add((loader, resource) => this.onLoaderProgress(loader, resource));
        this._loader.onError.add((error, loader, resource) => this.onLoaderError(error, loader, resource));
    }
    // https://github.com/nolimitcity/nolimit-slot-launcher/issues/336
    getQualitySetting() {
        switch (this._apiPlugin.options.quality) {
            case "high":
                return AssetsQualitySetting.HIGH;
            case "medium":
                return AssetsQualitySetting.MEDIUM;
            case "low":
                return AssetsQualitySetting.LOW;
            default:
                return AssetsQualitySetting.NONE;
        }
    }
    getDefaultQualities(forceSmartLoadingOff) {
        const quality = this.getQualitySetting();
        if (this._apiPlugin.options.smartLoading === false || forceSmartLoadingOff) {
            switch (quality) {
                case AssetsQualitySetting.HIGH:
                    return [Asset_1.AssetQualityLevel.HIGH];
                case AssetsQualitySetting.MEDIUM:
                    return [Asset_1.AssetQualityLevel.MEDIUM];
                case AssetsQualitySetting.LOW:
                    return [Asset_1.AssetQualityLevel.LOW];
                default:
                    return this._apiPlugin.options.device == APIOptions_1.Device.MOBILE ? [Asset_1.AssetQualityLevel.MEDIUM] : [Asset_1.AssetQualityLevel.HIGH];
            }
        }
        switch (quality) {
            case AssetsQualitySetting.HIGH:
                return [Asset_1.AssetQualityLevel.MEDIUM, Asset_1.AssetQualityLevel.HIGH];
            case AssetsQualitySetting.MEDIUM:
                return [Asset_1.AssetQualityLevel.LOW, Asset_1.AssetQualityLevel.MEDIUM];
            case AssetsQualitySetting.LOW:
                return [Asset_1.AssetQualityLevel.LOW];
            default:
                return this._apiPlugin.options.device == APIOptions_1.Device.MOBILE ? [Asset_1.AssetQualityLevel.LOW, Asset_1.AssetQualityLevel.MEDIUM] : [Asset_1.AssetQualityLevel.MEDIUM, Asset_1.AssetQualityLevel.HIGH];
        }
    }
    load(resourcesGroup) {
        return new Promise((resolve, reject) => {
            const assetGroups = AssetsConfig_1.AssetsConfig.getResourcesGroup(resourcesGroup);
            for (let assetGroup of assetGroups) {
                if (assetGroup && assetGroup.device && assetGroup.device !== this._apiPlugin.options.device) {
                    //Current asset group device doesn't match device. Removed from loading.
                    assetGroups.splice(assetGroups.indexOf(assetGroup), 1);
                }
            }
            this.loadResourceGroup(resourcesGroup, assetGroups);
            this._events.on(AssetLoaderEvent_1.AssetLoaderEvent.LEVEL_COMPLETE, (event) => {
                if (event.name == resourcesGroup && event.level == 1) {
                    resolve({});
                }
            });
        });
    }
    loadResourceGroup(resourceGroup, assetGroups) {
        this._loadLoopIndex = 0;
        this._totalAutoLoadLoops = 0;
        this._resourceGroup = resourceGroup;
        if (assetGroups == null) {
            console.warn("AssetLoader.loadResourceGroup, assetGroups is null");
            this._loadLoopIndex = 1;
            this.dispatchLoadLoopComplete();
            this.dispatchAllLoopsComplete();
            return;
        }
        this._assetsGroups = assetGroups;
        for (let assetGroup of this._assetsGroups) {
            if (assetGroup.autoLoad == null) {
                assetGroup.autoLoad = this.getDefaultQualities(assetGroup.forceSmartLoadingOff).concat();
            }
            assetGroup.autoLoad.unshift(Asset_1.AssetQualityLevel.META);
            this._totalAutoLoadLoops = this._totalAutoLoadLoops < assetGroup.autoLoad.length ? assetGroup.autoLoad.length : this._totalAutoLoadLoops;
            if (assetGroup.animations) {
                this._textureParser.addAnimationRegister(assetGroup.animations);
            }
        }
        this.autoLoadLevel();
    }
    addGroupToLoader(assetGroup) {
        const quality = assetGroup.autoLoad.shift();
        if (quality == undefined) {
            return 0;
        }
        let assetsAddedCount = 0;
        for (let asset of assetGroup.assets) {
            let variant = asset.variants[quality];
            if (variant) {
                this._loader.add(variant.name, this._baseUrl + variant.url);
                assetsAddedCount++;
            }
        }
        return assetsAddedCount;
    }
    autoLoadLevel() {
        let assetsAddedCount = 0;
        for (let i = 0; i < this._assetsGroups.length; i++) {
            assetsAddedCount += this.addGroupToLoader(this._assetsGroups[i]);
        }
        if (assetsAddedCount > 0) {
            this._loader.load((loader, resources) => this.onLevelLoaded(loader, resources));
        }
        else {
            this.onLevelLoaded(this._loader, this._resources);
        }
    }
    onLevelLoaded(loader, resources) {
        loader.reset();
        this.dispatchLoadLoopComplete();
        if (this._loadLoopIndex < this._totalAutoLoadLoops - 1) {
            this._loadLoopIndex++;
            this.autoLoadLevel();
            return;
        }
        //this._textureParser.destroyOldBaseTextures();
        this.dispatchAllLoopsComplete();
    }
    dispatchAllLoopsComplete() {
        Logger_1.Logger.logDev(`%cAssetLoader.dispatchAllLoopsComplete resourceGroup:${this._resourceGroup} , loadLoop: ${this._loadLoopIndex}`, 'background:#99ea99;');
        //TODO
        this._events.trigger(AssetLoaderEvent_1.AssetLoaderEvent.ALL_LEVELS_COMPLETE, new AssetLoaderEvent_1.AssetLoaderEvent(AssetLoaderEvent_1.AssetLoaderEvent.ALL_LEVELS_COMPLETE, this._resourceGroup, this._loadLoopIndex));
        //EventHandler.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.ALL_LEVELS_COMPLETE, this._resourceGroup, this._loadLoopIndex));
    }
    dispatchLoadLoopComplete() {
        Logger_1.Logger.logDev(`%cAssetLoader.dispatchLoadLoopComplete resourceGroup:${this._resourceGroup} , loadLoop: ${this._loadLoopIndex}`, 'background:#ddffdd;');
        if (this._resourceGroup === ResourcesGroupName_1.ResourcesGroupName.INTRO) {
            this._textureParser.ready = true;
        }
        //TODO
        this._events.trigger(AssetLoaderEvent_1.AssetLoaderEvent.LEVEL_COMPLETE, new AssetLoaderEvent_1.AssetLoaderEvent(AssetLoaderEvent_1.AssetLoaderEvent.LEVEL_COMPLETE, this._resourceGroup, this._loadLoopIndex));
        //EventHandler.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.LEVEL_COMPLETE, this._resourceGroup, this._loadLoopIndex));
    }
    getTextures(name) {
        return this._textureParser.getFrameTextures(name);
    }
    getSpineAsset(name) {
        return this._spineAssetParser.getSpineAsset(name);
    }
    /**
     * On load progress handler
     *
     * @param loader
     * @param resource
     */
    onLoaderProgress(loader, resource) {
        //const progress:number = loader.progress;
        //const resourceLoaded:PIXI.loaders.Resource = resource;
        //progress bar?
        this.dispatchProgress(loader.progress);
    }
    dispatchProgress(progress) {
        //TODO
        this._events.trigger(AssetLoaderEvent_1.AssetLoaderEvent.PROGRESS, new AssetLoaderEvent_1.AssetLoaderEvent(AssetLoaderEvent_1.AssetLoaderEvent.PROGRESS, this._resourceGroup, this._loadLoopIndex, progress));
        //   EventHandler.dispatchEvent(new AssetLoaderEvent(AssetLoaderEvent.PROGRESS, this._resourceGroup, this._loadLoopIndex, progress));
    }
    /**
     * On load error handler
     * @param error
     * @param loader
     * @param resource
     */
    onLoaderError(error, loader, resource) {
        Logger_1.Logger.logDev(error.message, loader, resource);
        this._apiPlugin.error.trigger(error.message, APIErrorSystem_1.APIErrorCode.JAVASCRIPT);
    }
    halt() {
        this._loader.destroy();
    }
}
exports.AssetLoader = AssetLoader;
//# sourceMappingURL=AssetLoader.js.map